<template>
  <span class="text-highlight" v-html="content"></span>
</template>

<script>

export default {
  name: 'text-highlight',
  props: {
    val: {
      default: '',
    },
    highlightKey: {
      default: '',
    },
    color: {
      default: '#FF6700',
    },
  },
  computed: {
    content() {
      const highlightKey = this.highlightKey;
      const color = this.color;
      let val = this.val;
      // if (val && highlightKey) {
      //   val = val.replace(
      //       RegExp(highlightKey, 'g'),
      //       `<span style="color: ${color}">${highlightKey}</span>`,
      //   );
      // }
      return val;
    },
  }
}
</script>
